var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChervon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8939 20.057L2.05234 11.0916L10.8939 2.12632C11.0521 1.96614 11.1408 1.75111 11.1408 1.5272C11.1408 1.30329 11.0521 1.08826 10.8939 0.928076C10.817 0.850517 10.7252 0.7889 10.6239 0.746836C10.5227 0.704772 10.4139 0.683105 10.3041 0.683105C10.1942 0.683105 10.0855 0.704772 9.98419 0.746836C9.88291 0.7889 9.79115 0.850517 9.71427 0.928076L0.306541 10.4656C0.141372 10.6331 0.0489326 10.8578 0.0489326 11.0916C0.0489326 11.3255 0.141372 11.5502 0.306541 11.7177L9.71245 21.2552C9.78939 21.3333 9.88138 21.3954 9.98299 21.4378C10.0846 21.4802 10.1938 21.502 10.3041 21.502C10.4144 21.502 10.5235 21.4802 10.6251 21.4378C10.7267 21.3954 10.8187 21.3333 10.8957 21.2552C11.054 21.095 11.1426 20.88 11.1426 20.6561C11.1426 20.4322 11.054 20.2172 10.8957 20.057L10.8939 20.057Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChervon);
export default __webpack_public_path__ + "static/media/LeftChervon.4a361f5c9328c2dbbde4875b385830c5.svg";
export { ForwardRef as ReactComponent };